import { cn } from 'corso-admin-ui';
import FallbackImage from './FallbackImage';
import { MediaPreview } from './media/MediaPreview';

export default function ProductImage({
  src,
  alt,
  className,
}: {
  src?: string | null;
  alt: string;
  className?: string;
}) {
  const imageClassName = cn(
    'aspect-square rounded-md border object-contain object-center',
    className,
  );

  if (!src) {
    return <FallbackImage alt={alt} src={src} className={imageClassName} />;
  }

  return (
    <MediaPreview src={src} alt={alt} expandable className={imageClassName} />
  );
}
